import React from 'react';
import { Spinner as SpinnerOriginal } from '@nextiva/next-ui';

export const Spinner = props => (
  <SpinnerOriginal
    style={{
      position: 'absolute',
    }}
    size={30}
    thickness={1.2}
    {...props}
  />
);
